import React, { useEffect } from "react";
import { Table } from "antd";
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { useDispatch, useSelector } from "react-redux";
import AnnouncementForm from "./AnnouncementForm"; 
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import { MODULE_ANNOUNCEMENTS } from "variables/modules";
import { 
  doAnnouncementDelete,
  doAnnouncementReset, 
  getAnnouncementList 
} from "../../../../redux/announcement/announcementState";
import { displayIcon } from "variables/icons";
import { getAnnouncementCategoryList } from "../../../../redux/optionlist/optionlistState";
import { ROLE_SUPER_ADMIN } from "variables/constants";
import TableAddButton from "components/button/tableaddbutton";

const AnnouncementTable = ({ }) => {
    const dispatch = useDispatch();
    const recordList = useSelector((state) => state.announcement.announcementList?.items);
    const pagination = useSelector((state) => state.announcement.announcementList?.pagination);
    const filters = useSelector((state) => state.announcement.announcementList?.filters);
    const announcementCategoryList = useSelector((state) => state.optionlist.announcementCategoryList?.items);
    const authUser = useSelector((state) => state.auth.user);

    const doSearch = (filters) => dispatch(getAnnouncementList(filters));
    const doDelete = (id) => dispatch(doAnnouncementDelete(id));
    const doRecordReset = () => dispatch(doAnnouncementReset());

    const columns = [
      {
        title: "Announcement Title",
        dataIndex: "ann_title",
        key: "ann_title",
        width: "20%",
        render: (ann_title) => <span>{ann_title}</span>,
      },
      {
        title: "Icon",
        dataIndex: "ann_icon",
        key: "ann_icon",
        width: "5%",
        render: (ann_icon) => 
          <span className="flex items-center gap-1">
            {displayIcon(ann_icon, "w-5 h-5 title-text")}
          </span>,
      },
      {
        title: "Description",
        dataIndex: "ann_description",
        key: "ann_description",
        width: "45%",
        render: (ann_description) => <span>{ann_description}</span>,
      },
      {
        title: "Category",
        dataIndex: "ann_category",
        key: "ann_category",
        width: "5%",
        filters: announcementCategoryList?.map((category) => ({
          text: category.label,
          value: category.value
        })) || [],
        render: (_, record) => (
          <span>{record?.category_name}</span>
        ),
      },
      {
        title: "Duration",
        key: "announcement_period",
        width: "20%",
        render: (_, record) => (
          <>
          <span className="flex gap-1">
            <div>{record?.ann_period_from} {" - "} 
              {record?.ann_period_to || "Present"}
            </div>
          </span>
          </>
        ),

      },
      {
        title: <TableAddButton route={`/console/announcements/add`} moduleId={MODULE_ANNOUNCEMENTS}/>,
        dataIndex: "ann_id",
        key: "ann_id",
        width: "10%",
        render: (_, record) => (
          <CrudOption
            baseRoute="/console/announcements"
            recordId={record?.ann_id}
            deleteHandler={doDelete}
            allowEdit={authUser?.user_level === ROLE_SUPER_ADMIN || !record?.creator_is_super_admin}
            allowDelete={authUser?.user_level === ROLE_SUPER_ADMIN || !record?.creator_is_super_admin}
            allowView={true}
            title="Edit Announcement"
          />
        ),
      },
    ];

    useEffect(() => {
        dispatch(getAnnouncementList({ paginate: pagination.per_page }));
        dispatch(getAnnouncementCategoryList());
    }, [dispatch, pagination.per_page]);
	
    return (
      <Card extra={"w-full h-full p-4"}>
        <div className="h-full w-full overflow-x-auto">
          <Table
            dataSource={recordList}
            columns={columns}
            rowKey={(record) => record.ann_id}
            scroll={{ x: 600 }}
            pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}   
            onChange={handleTableChange(doSearch, filters)}
          />
        </div>
      </Card>
    );
};

export default AnnouncementTable;
